@if (faqModel !=undefined ){<section class="faq-container" aria-labelledby="faq-title">
    <h1 id="faq-title" class="faq-title">{{ faqModel.title }}</h1>
    <p class="faq-description">{{ faqModel.description }}</p>
    <ul class="faq-list">
        @for (item of faqModel.items; track item.order) {
        <li class="faq-card">
            <div class="faq-row" itemscope itemtype="https://schema.org/Question">
                <span class="faq-question-text" itemprop="name">
                    {{ item.question }}
                </span>
                <button name="btn-expand" class="faq-expand-btn" type="button" (click)="item.open = !item.open"
                    [attr.aria-expanded]="item.open" [attr.aria-controls]="'answer-' + item.order"
                    [attr.aria-label]="item.open ? 'Collapse answer' : 'Expand answer'">

                    <span aria-hidden="true" [class.expanded]="item.open">
                        {{ item.open ? '−' : '+' }}
                    </span>
                </button>
            </div>
            @if (item.open) {
            <div class="faq-answer" [id]="'answer-' + item.order" itemscope itemprop="acceptedAnswer"
                itemtype="https://schema.org/Answer">
                <p itemprop="text" [innerHTML]="item.answer">
                </p>
            </div>
            }
        </li>
        }
    </ul>
</section>}